module.exports = __webpack_public_path__ + "media/images/feeling_confused-3a595311.svg";